import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { AdminRouteSkeleton } from '@/components/RouteSkeleton';

interface AdminRouteProps {
  children: React.ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps) {
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  // Stay in spinner while session + profile are both loading
  // user is set immediately, but profile is fetched after auth resolves
  if (loading || (user && profile === null)) {
    return <AdminRouteSkeleton />;
  }

  // Not logged in at all
  if (!user) {
    return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} replace />;
  }

  // Logged in but not admin — redirect to home silently
  if (!profile?.is_admin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
